import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.066 8.002a9 9 0 1 0 .934 3.998h-13","key":"svg-0"}],["path",{"d":"M12 8l-4 4l4 4","key":"svg-1"}]]

const IconCircleOpenArrowLeft = createReactComponent('outline', 'circle-open-arrow-left', 'CircleOpenArrowLeft', __iconNode);

export default IconCircleOpenArrowLeft;